import { render, staticRenderFns } from "./JcdcBtn.vue?vue&type=template&id=319f59f0"
import script from "./JcdcBtn.vue?vue&type=script&lang=ts"
export * from "./JcdcBtn.vue?vue&type=script&lang=ts"
import style0 from "./JcdcBtn.vue?vue&type=style&index=0&id=319f59f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports